import $ from 'jquery';

import FormFieldComponent from 'chairisher/component/form/field';

import { getDefaultCheckboxError } from 'chairisher/context/error';

const TOS_FIELD_NAME = 'tos_opt_in';

/**
 * Determines if a ToS field is present and accepted
 *
 * @param {JQuery|HTMLElement} form The form element
 * @returns {boolean}
 */
export function isTosAccepted(form) {
    const $tosOptInField = $(form).find(`[name="${TOS_FIELD_NAME}"]`);
    return !$tosOptInField.length || $tosOptInField.prop('disabled') || $tosOptInField.prop('checked');
}

/**
 * Renders a default error on the ToS checkbox field
 *
 * @param {JQuery|HTMLElement} form The form element
 */
export function renderDefaultErrorOnTosField(form) {
    const $tosOptInField = $(form).find(`[name="${TOS_FIELD_NAME}"]`);
    const tosField = new FormFieldComponent({
        data: {},
        $el: $tosOptInField,
        name: TOS_FIELD_NAME,
    });

    tosField.renderErrors([{ display: getDefaultCheckboxError() }]);
}
